export class AboutUsModel{
    constructor(public id: number, public title: string, public description: string, public image: string){}
}